import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../utils/api";
import { clearToken } from "../../utils/authUtils";
import "./sidebar.css"
import defaultLogo from "../../../src/assets/logo/printlogo.png";


const Sidebar = () => {
  const navigate = useNavigate();
  const [menus, setMenus] = useState([]);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

const [logo, setLogo] = useState(localStorage.getItem("logo1") || defaultLogo);
  useEffect(() => {
    handleMenu();


    // Handle screen resizing
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 992); // Only show sidebar on desktop
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);





  async function handleMenu() {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "getMenuSubmenuDetails";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);

    try {
      const response = await api.post("user/userCurl", fd);
      if (response.data.status === "success") {
        setMenus(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching menu details:", error);
    }
  }

  // Only render if screen is desktop
  if (!isDesktop) return null;

  // --- Inline Styles for Modern Look ---
  const styles = {
    sidebarContainer: {
      background: "#121A2C", // Modern Dark Gradient
      boxShadow: "4px 0 20px rgba(0,0,0,0.2)",
      color: "#e2e8f0",
      borderRight: "1px solid rgba(255,255,255,0.05)",
      height: "100vh",
    },
    logoContainer: {
      backgroundColor: "transparent", // Overriding bg-white
      borderBottom: "1px solid rgba(255,255,255,0.1)",
      backdropFilter: "blur(10px)",
    },
    logoImage: {
      // This filter turns black logos white to match the dark theme
      filter: "brightness(0) invert(1)",
      opacity: "0.9",
    },
    menuIcon: {
      color: "#94a3b8", // Muted slate color for icons
      fontSize: "22px",
      transition: "color 0.3s ease",
    },
    menuText: {
      color: "#f8fafc", // Bright white/gray for text
      fontWeight: "500",
      letterSpacing: "0.5px",
      fontFamily: "'Inter', sans-serif",
    },
    closeBtn: {
      background: "rgba(255,255,255,0.1)",
      color: "#fff",
      borderColor: "transparent",
    },
  };

  return (
    <aside
      className="sidebar d-flex flex-column"
      style={styles.sidebarContainer}
    >
      {/* Sidebar close button */}
      <button
        type="button"
        className="sidebar-close-btn text-gray-500 hover-text-white hover-bg-main-600 text-md w-24 h-24 border border-gray-100 hover-border-main-600 d-xl-none d-flex flex-center rounded-circle position-absolute"
        style={styles.closeBtn}
      >
        <i className="ph ph-x"></i>
      </button>

      {/* Logo */}
      <Link
        to="/admin-dashboard2"
        className="sidebar__logo text-center p-20 position-sticky inset-block-start-0 w-100 z-1 pb-10"
        style={{
          backdropFilter: "blur(6px)",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <img
          src={logo}
          alt="Logo"
          width="100px"
        />
      </Link>

      <div className="sidebar-menu-wrapper overflow-y-auto scroll-sm d-flex flex-column flex-grow-1">
        <div className="p-20 pt-10 flex-grow-1">
          <ul className="sidebar-menu">

            {/* Dashboard Section */}
            <li className="sidebar-menu__item">
              <Link to="/admin-dashboard2" className="sidebar-menu__link">
                <span className="icon">
                  <i
                    className="ph ph-squares-four"
                    style={styles.menuIcon}
                  ></i>
                </span>
                <span className="text" style={styles.menuText}>
                  Dashboard
                </span>
              </Link>
            </li>

            <li className="sidebar-menu__item">
              <Link to="/settings" className="sidebar-menu__link">
                <span className="icon">
                  <i
                    className="ph ph-gear"
                    style={styles.menuIcon}
                  ></i>
                </span>
                <span className="text" style={styles.menuText}>
                  Settings
                </span>
              </Link>
            </li>

            {/* Questions Section */}
            <li className="sidebar-menu__item">
              <Link to="/questions" className="sidebar-menu__link">
                <span className="icon">
                  <i
                    className="ph ph-question"
                    style={styles.menuIcon}
                  ></i>
                </span>
                <span className="text" style={styles.menuText}>
                  Question Bank
                </span>
              </Link>
            </li>

            {/* Paper Section */}
            <li className="sidebar-menu__item">
              <Link to="/paper-details" className="sidebar-menu__link">
                <span className="icon">
                  <i
                    className="ph ph-scroll"
                    style={styles.menuIcon}
                  ></i>
                </span>
                <span className="text" style={styles.menuText}>
                  Question Paper
                </span>
              </Link>
            </li>

            <li className="sidebar-menu__item">
              <Link to="/template-details" className="sidebar-menu__link">
                <span className="icon">
                  <i
                    className="ph ph-list-dashes"
                    style={styles.menuIcon}
                  ></i>
                </span>
                <span className="text" style={styles.menuText}>
                  Template
                </span>
              </Link>
            </li>


            {/* Student Section */}
            {/* <li className="sidebar-menu__item">
              <Link to="/student-list" className="sidebar-menu__link">
                <span className="icon">
                  <i
                    className="ph ph-users"
                    style={styles.menuIcon}
                  ></i>
                </span>
                <span className="text" style={styles.menuText}>
                  Students
                </span>
              </Link>
            </li> */}

            {/* Staff Section */}
            <li className="sidebar-menu__item">
              <Link to="/staff-role" className="sidebar-menu__link">
                <span className="icon">
                  <i
                    className="ph ph-users"
                    style={styles.menuIcon}
                  ></i>
                </span>
                <span className="text" style={styles.menuText}>
                  Staff
                </span>
              </Link>
            </li>

            <li className="sidebar-menu__item">
              <Link to="/leaderboard" className="sidebar-menu__link">
                <span className="icon">
                  <i
                    className="ph ph-medal"
                    style={styles.menuIcon}
                  ></i>
                </span>
                <span className="text" style={styles.menuText}>
                  Leaderboard
                </span>
              </Link>
            </li>

          </ul>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;